import { render, staticRenderFns } from "./PageClubTransfers.vue?vue&type=template&id=63cf0ab9&scoped=true&"
import script from "./PageClubTransfers.vue?vue&type=script&lang=js&"
export * from "./PageClubTransfers.vue?vue&type=script&lang=js&"
import style0 from "./PageClubTransfers.vue?vue&type=style&index=0&id=63cf0ab9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cf0ab9",
  null
  
)

export default component.exports